// src/styles/NotebookStyles.js
import styled from 'styled-components';
import { Card, StyledButton, StyledTextarea as CommonTextarea } from '../main/CommonStyles';

// ... (istniejące style: NotebookPageWrapper, NotebookLayout, CalendarColumn, NotesColumn, CalendarWrapper)

export const NoteEditorWrapper = styled(Card)`
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing.md};
    flex-grow: 1;
`;

export const DateHeader = styled.h2`
    font-family: ${({ theme }) => theme.fonts.headings};
    font-size: 1.5rem;
    font-weight: 700;
    color: ${({ theme }) => theme.colors.primaryDark};
    margin-bottom: ${({ theme }) => theme.spacing.xs}; // Zmniejszony margines
`;

export const NotesList = styled.div`
    margin-top: ${({ theme }) => theme.spacing.md};
    margin-bottom: ${({ theme }) => theme.spacing.md};
    max-height: 250px; // Ograniczenie wysokości, aby nie rozciągało za bardzo
    overflow-y: auto;
    padding-right: ${({ theme }) => theme.spacing.sm}; // Miejsce na scrollbar
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing.sm};
`;

export const NoteItem = styled.div`
    background-color: ${({ theme }) => theme.colors.neutralLight};
    padding: ${({ theme }) => theme.spacing.sm} ${({ theme }) => theme.spacing.md};
    border-radius: ${({ theme }) => theme.borderRadius};
    font-size: 0.9rem;
    color: ${({ theme }) => theme.colors.textDark};
    border: 1px solid ${({ theme }) => theme.colors.borderColor};
    display: flex;
    justify-content: space-between;
    align-items: flex-start; // Aby przycisk był wyrównany z początkiem tekstu

    p {
        margin: 0;
        white-space: pre-wrap; // Zachowanie formatowania (np. nowych linii)
        word-break: break-word; // Łamanie długich słów
        flex-grow: 1;
        margin-right: ${({ theme }) => theme.spacing.sm};
    }

    // Można dodać przyciski edycji/usunięcia
    button {
        background: none;
        border: none;
        color: ${({ theme }) => theme.colors.textMedium};
        cursor: pointer;
        padding: 0;
        margin-left: ${({ theme }) => theme.spacing.sm};
        &:hover {
            color: ${({ theme }) => theme.colors.primary};
        }
    }
`;

export const NewNoteSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing.sm};
    margin-top: ${({ theme }) => theme.spacing.sm};
`;

export const NoteTextarea = styled(CommonTextarea)`
    min-height: 80px; // Mniejsza wysokość dla dodawania nowej notatki
    font-size: 0.95rem;
`;

export const AddNoteButton = styled(StyledButton)`
    align-self: flex-end;
    padding: ${({ theme }) => theme.spacing.xs} ${({ theme }) => theme.spacing.md}; // Mniejszy przycisk
    font-size: 0.85rem;
`;

export const SaveDayButton = styled(StyledButton)`
    align-self: flex-end;
    margin-top: ${({ theme }) => theme.spacing.md};
    background-color: ${({ theme }) => theme.colors.secondary};
    &:hover {
        background-color: ${({ theme }) => theme.colors.secondaryDark};
    }
`;

// ... (istniejące style: MoodTrackerWrapper, MoodSelector, MoodButton)

// Istniejące style (bez zmian, dla kontekstu)
export const NotebookPageWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing.lg};
    height: 100%; 
`;

export const NotebookLayout = styled.div`
    display: grid;
    grid-template-columns: 1fr; 
    gap: ${({ theme }) => theme.spacing.lg};
    flex-grow: 1; 

    @media (min-width: 992px) { 
        grid-template-columns: minmax(320px, 1fr) 2fr; // Zwiększona szerokość kalendarza
    }
`;

export const CalendarColumn = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing.lg};
`;

export const NotesColumn = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing.lg};
`;

export const CalendarWrapper = styled(Card)`
    padding: ${({ theme }) => theme.spacing.md}; 
    .react-calendar {
        width: 100%;
        border: none;
        font-family: ${({ theme }) => theme.fonts.main};
        background-color: ${({ theme }) => theme.colors.white};
    }

    .react-calendar__navigation button {
        color: ${({ theme }) => theme.colors.primary};
        min-width: 44px;
        background: none;
        font-size: 1rem;
        font-weight: 600;
        font-family: ${({ theme }) => theme.fonts.headings};
        margin-top: ${({ theme }) => theme.spacing.sm};
    }
    .react-calendar__navigation button:enabled:hover,
    .react-calendar__navigation button:enabled:focus {
        background-color: ${({ theme }) => theme.colors.primaryLightest};
    }
    .react-calendar__month-view__weekdays__weekday {
        text-align: center;
        font-weight: 500;
        font-size: 0.75rem;
        color: ${({ theme }) => theme.colors.textMedium};
        abbr {
          text-decoration: none;
        }
    }
    .react-calendar__tile {
        background: none;
        text-align: center;
        line-height: 2rem; 
        font-size: 0.875rem;
        border-radius: ${({ theme }) => theme.borderRadius};
        transition: background-color 0.2s, color 0.2s;
        height: 40px; // Stała wysokość kafelka
    }
    .react-calendar__tile:enabled:hover,
    .react-calendar__tile:enabled:focus {
        background-color: ${({ theme }) => theme.colors.primaryLightest};
        color: ${({ theme }) => theme.colors.primaryDark};
    }
    .react-calendar__tile--now { 
        background: ${({ theme }) => theme.colors.secondaryLight + '4D'}; 
        color: ${({ theme }) => theme.colors.secondaryDark};
        font-weight: 600;
    }
    .react-calendar__tile--active { 
        background: ${({ theme }) => theme.colors.primary};
        color: white;
        font-weight: 600;
    }
    .react-calendar__tile--active:enabled:hover,
    .react-calendar__tile--active:enabled:focus {
        background: ${({ theme }) => theme.colors.primaryDark};
    }
    .day-with-note {
        position: relative;
        abbr {
            position: relative;
            z-index: 1;
        }
        &:after {
            content: '';
            position: absolute;
            bottom: 4px; // Dostosuj pozycję kropki
            left: 50%;
            transform: translateX(-50%);
            width: 6px;
            height: 6px;
            border-radius: 50%;
            background-color: ${({ theme }) => theme.colors.secondary}; 
        }
    }
    .react-calendar__tile--active.day-with-note:after {
        background-color: white; 
    }
`;

export const MoodTrackerWrapper = styled(Card)`
    h3 {
        font-family: ${({ theme }) => theme.fonts.headings};
        font-size: 1.1rem;
        font-weight: 600;
        color: ${({ theme }) => theme.colors.textDark};
        margin-bottom: ${({ theme }) => theme.spacing.md};
        text-align: center;
    }
`;

export const MoodSelector = styled.div`
    display: flex;
    justify-content: space-around;
    align-items: center;
    gap: ${({ theme }) => theme.spacing.xs}; // Zmniejszony gap
`;

export const MoodButton = styled.button`
    background: none;
    border: none;
    padding: ${({ theme }) => theme.spacing.sm};
    border-radius: 50%;
    cursor: pointer;
    transition: background-color 0.2s, transform 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
        width: 28px; // Nieco mniejsze emotki
        height: 28px;
    }

    &:hover {
        background-color: ${({ theme }) => theme.colors.neutralLight};
        transform: scale(1.1);
    }

    &.selected {
        background-color: ${({ theme, moodcolor }) => moodcolor || theme.colors.primaryLightest};
        box-shadow: 0 0 0 2px ${({ theme, moodcolor }) => moodcolor || theme.colors.primary};
        transform: scale(1.1);
    }

    &.mood-terrible svg { fill: #EF5350; color: #fff; }
    &.mood-bad svg { fill: #FF7043; color: #fff; }
    &.mood-neutral svg { fill: #FFEE58; color: #424242; }
    &.mood-good svg { fill: #9CCC65; color: #fff;}
    &.mood-great svg { fill: #66BB6A; color: #fff;}

    &.selected.mood-terrible { background-color: #FFCDD2; box-shadow: 0 0 0 3px #EF5350; }
    &.selected.mood-bad { background-color: #FFCCBC; box-shadow: 0 0 0 3px #FF7043; }
    &.selected.mood-neutral { background-color: #FFF9C4; box-shadow: 0 0 0 3px #FFCA28; } // Ciemniejszy żółty dla kontrastu
    &.selected.mood-good { background-color: #E6EE9C; box-shadow: 0 0 0 3px #9CCC65; }
    &.selected.mood-great { background-color: #C8E6C9; box-shadow: 0 0 0 3px #66BB6A; }
`;